export function averageGroup(original) {
  const ret1 = [];
  const ret2 = [];
  for (let i = 0; i < original.length; i++) {
    const item = original[i];
    const halfIndex = Math.ceil(item.length / 2);
    ret1.push(item.slice(0, halfIndex));
    ret2.push(item.slice(halfIndex));
  }
  return [ret1, ret2];
}

export function battleTeamNum(teams) {
  return teams?.[0]?.length ? teams[0].length * 2 : 0;
}

